/* =========================================================
   VS BRAND PROMISE
   ========================================================= */

(function () {
  'use strict';

  function initBrandPromise(section) {
    if (!section) return;

    const items = section.querySelectorAll('.vs-bp-item');

    if (!items.length) return;

    /*
     * Lightweight reveal effect.
     * It automatically disables itself when the browser
     * or user prefers reduced motion.
     */

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (reducedMotion) {
      items.forEach(function (item) {
        item.style.opacity = '1';
        item.style.transform = 'none';
      });

      return;
    }

    items.forEach(function (item) {
      item.style.opacity = '0';
      item.style.transform = 'translateY(12px)';
      item.style.transition =
        'opacity 500ms ease, transform 500ms ease';
    });

    if ('IntersectionObserver' in window) {

      const observer = new IntersectionObserver(
        function (entries, observerInstance) {

          entries.forEach(function (entry) {

            if (!entry.isIntersecting) return;

            const item = entry.target;

            item.style.opacity = '1';
            item.style.transform = 'translateY(0)';

            observerInstance.unobserve(item);

          });

        },
        {
          threshold: 0.15
        }
      );

      items.forEach(function (item) {
        observer.observe(item);
      });

    } else {

      items.forEach(function (item) {
        item.style.opacity = '1';
        item.style.transform = 'translateY(0)';
      });

    }
  }


  function initAllBrandPromiseSections() {
    document
      .querySelectorAll('.vs-brand-promise')
      .forEach(function (section) {
        initBrandPromise(section);
      });
  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAllBrandPromiseSections
    );

  } else {

    initAllBrandPromiseSections();

  }


  /*
   * Shopify Theme Editor support
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section = event.target.querySelector(
        '.vs-brand-promise'
      );

      if (section) {
        initBrandPromise(section);
      }

    }
  );

})();